import useQuery from './useQuery';

export default function useQueryBrandRegion(defaults) {
  const query = useQuery();
  const brand = query.has('brand') ? query.get('brand') : defaults.brand;
  const region = query.has('region') ? query.get('region') : defaults.region;
  return { brand, region };
}
